export default __webpack_public_path__ + "static/media/Manacles of the Endless Sands.a4c5aa88.jpg";